import * as Catalog from './catalog';
import * as Checkout from './checkout';
import * as SaleOrder from './saleOrder';
import * as User from './user';

export const Repositories = {
  User,
  Catalog,
  Checkout,
  SaleOrder,
};
